import {albumApiData} from './albumApiData'
import {gardenApiData} from './gardenApiData'
import {researchApiData} from './researchApiData'
export const apiData = {
  // 基础数据
  'stageList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '基础数据API', '获取学段列表'],
    title: '获取学段列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '400px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取学段列表', url: '/api/v1/invoke-v2/phases', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: '无', type: '无', required: '无', description: '无' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '学段id' },
        { paras: 'name', type: 'String', description: '学段名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 2,
        "name": "小学"
      }, {
        "id": 3,
        "name": "初中"
      }, {
        "id": 4,
        "name": "高中"
      }]
    }
    `
  },
  'subjectList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '基础数据API', '获取学科列表'],
    title: '获取学科列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取学科列表', url: '/api/v1/invoke-v2/subjects', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'stageId', type: 'Int', required: '必填', description: '学段id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '学科id' },
        { paras: 'name', type: 'String', description: '学科名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 12,
        "name": "英语"
      }, {
        "id": 11,
        "name": "数学"
      }, {
        "id": 10,
        "name": "语文"
      }, {
        "id": 13,
        "name": "物理"
      }, {
        "id": 15,
        "name": "生物"
      }, {
        "id": 14,
        "name": "化学"
      }, {
        "id": 16,
        "name": "道德与法治"
      }, {
        "id": 17,
        "name": "历史"
      }, {
        "id": 18,
        "name": "地理"
      }, {
        "id": 19,
        "name": "科学"
      }, {
        "id": 20,
        "name": "信息技术"
      }, {
        "id": 21,
        "name": "历史与社会"
      }, {
        "id": 24,
        "name": "体育与健康"
      }]
    }
    `
  },
  'gradeList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '基础数据API', '获取年级列表'],
    title: '获取年级列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取年级列表', url: '/api/v1/invoke-v2/grades', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'stageId', type: 'Int', required: '必填', description: '学段id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '年级id' },
        { paras: 'name', type: 'String', description: '年级名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 10,
        "name": "高一"
      }, {
        "id": 11,
        "name": "高二"
      }, {
        "id": 12,
        "name": "高三"
      }]
    }
    `
  },
  'provinceList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '基础数据API', '获取省份列表'],
    title: '获取省份列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取省份列表', url: '/api/v1/invoke-v2/provinces', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: '无', type: '无', required: '无', description: '无' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '省份id' },
        { paras: 'name', type: 'String', description: '省份名称' },
        { paras: 'parentId', type: 'Int', description: '父级id' },
        { paras: 'level', type: 'Int', description: '层级' },
        { paras: 'children', type: 'Object', description: '子集合' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 110000,
        "name": "北京",
        "shortName": "北京",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 120000,
        "name": "天津",
        "shortName": "天津",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 130000,
        "name": "河北省",
        "shortName": "河北",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 140000,
        "name": "山西省",
        "shortName": "山西",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 150000,
        "name": "内蒙古自治区",
        "shortName": "内蒙古",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 210000,
        "name": "辽宁省",
        "shortName": "辽宁",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 220000,
        "name": "吉林省",
        "shortName": "吉林",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 230000,
        "name": "黑龙江省",
        "shortName": "黑龙江",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 310000,
        "name": "上海",
        "shortName": "上海",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 320000,
        "name": "江苏省",
        "shortName": "江苏",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 330000,
        "name": "浙江省",
        "shortName": "浙江",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 340000,
        "name": "安徽省",
        "shortName": "安徽",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 350000,
        "name": "福建省",
        "shortName": "福建",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 360000,
        "name": "江西省",
        "shortName": "江西",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 370000,
        "name": "山东省",
        "shortName": "山东",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 410000,
        "name": "河南省",
        "shortName": "河南",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 420000,
        "name": "湖北省",
        "shortName": "湖北",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 430000,
        "name": "湖南省",
        "shortName": "湖南",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 440000,
        "name": "广东省",
        "shortName": "广东",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 450000,
        "name": "广西壮族自治区",
        "shortName": "广西",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 460000,
        "name": "海南省",
        "shortName": "海南",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 500000,
        "name": "重庆",
        "shortName": "重庆",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 510000,
        "name": "四川省",
        "shortName": "四川",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 520000,
        "name": "贵州省",
        "shortName": "贵州",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 530000,
        "name": "云南省",
        "shortName": "云南",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 540000,
        "name": "西藏自治区",
        "shortName": "西藏",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 610000,
        "name": "陕西省",
        "shortName": "陕西",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 620000,
        "name": "甘肃省",
        "shortName": "甘肃",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 630000,
        "name": "青海省",
        "shortName": "青海",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 640000,
        "name": "宁夏回族自治区",
        "shortName": "宁夏",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 650000,
        "name": "新疆维吾尔自治区",
        "shortName": "新疆",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 810000,
        "name": "香港特别行政区",
        "shortName": "香港",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 820000,
        "name": "澳门特别行政区",
        "shortName": "澳门",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 710000,
        "name": "台湾",
        "shortName": "台湾",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 2,
        "name": "全国",
        "shortName": "全国",
        "parentId": 1,
        "level": 1,
        "children": null
      }, {
        "id": 999999,
        "name": "其他",
        "shortName": "其他",
        "parentId": 1,
        "level": 1,
        "children": null
      }]
    }
    `
  },
  // 文档资源
  'docColumnList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['开发文档', 'API文档', '目录接口', '获取文档栏目'],
    title: '获取文档栏目', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取文档栏目', url: '/api/v1/invoke-v2/doc/columns', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'stageId', type: 'Int', required: '必填', description: '学段id' },
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '栏目id' },
        { paras: 'name', type: 'String', description: '栏目名称' },
        { paras: 'columnType', type: 'Int', description: '1. 同步资源 3.一轮复习 4.二轮复习' }
      ]
    },
    showResponseCode: true,
    responseCode: `{
      "code": 1,
      "msg": "成功",
      "data": [{
          "id": 3,
          "name": "同步备课",
          "columnType": 1
        },
        {
          "id": 12,
          "name": "一轮复习",
          "columnType": 3
        },
        {
          "id": 13,
          "name": "二轮复习",
          "columnType": 4
      }]
    }`
  },
  'docTypeList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '文档资源', '获取文档类型'],
    title: '获取文档类型', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取文档类型', url: '/api/v1/invoke-v2/doc/document/types', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: '无', type: '无', required: '无', description: '无' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '文档类型id' },
        { paras: 'name', type: 'String', description: '文档类型名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
          "code": 1,
          "msg": "成功",
          "data": [
               {
                  "id": 1,
                  "name": "课件"
              },
              {
                  "id": 2,
                  "name": "教案"
              },
              {
                  "id": 3,
                  "name": "习题/作业"
              }
           ]
      }
    `
  },
  'docVersionList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '文档资源', '获取文档版本'],
    title: '获取文档版本', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取版本列表', url: '/api/v1/invoke-v2/doc/versions', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科id' },
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '版本id' },
        { paras: 'name', type: 'String', description: '版本名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 742,
        "name": "统编版",
        "bookFlag": 1
      }]
    }
    `
  },
  'docTextbookList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '文档资源', '获取文档册别'],
    title: '获取文档册别', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取文档册别', url: '/api/v1/invoke-v2/doc/textbooks', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'versionId', type: 'Int', required: '必填', description: '版本id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '册别id' },
        { paras: 'name', type: 'String', description: '册别名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 798,
        "name": "必修1"
      }, {
        "id": 799,
        "name": "必修2"
      }]
    }
    `
  },
  'docBooknodeList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '文档资源', '获取文档章节'],
    title: '获取文档章节', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取文档章节', url: '/api/v1/invoke-v2/doc/bookNodes', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'textbookId', type: 'Int', required: '必填', description: '册别id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '章节id' },
        { paras: 'name', type: 'String', description: '章节名称' },
        { paras: 'pathIds', type: 'String', description: '章节路径' },
        { paras: 'textbookId', type: 'Int', description: '册别id' },
        { paras: 'children', type: 'Array', description: '子章节' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 20443,
        "name": "第一单元 家国情怀",
        "pathIds": "20443,",
        "textbookId": 798,
        "children": [{
          "id": 20444,
          "name": "1.我们对香港问题的基本立场  邓小平",
          "pathIds": "20443,20444,",
          "textbookId": 798
        }]
      }]
    }
    `
  },
  'docKnowledgeList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '文档资源', '获取文档知识点'],
    title: '获取文档知识点', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取文档知识点', url: '/api/v1/invoke-v2/doc/knowledgePoints', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'columnId', type: 'Int', required: '必填', description: '文档栏目id, 请填写一轮复习和二轮复习的id' },
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '知识点id' },
        { paras: 'name', type: 'String', description: '知识点名称' },
        { paras: 'pathIds', type: 'String', description: '知识点路径' },
        { paras: 'subjectId', type: 'Int', description: '学科id' },
        { paras: 'parentId', type: 'Int', description: '父节点' },
        { paras: 'depth', type: 'Int', description: '层级' },
        { paras: 'childrenNode', type: 'Array', description: '子知识点' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 227623,
        "name": "cn",
        "pathIds": "227623,",
        "subjectId": 26,
        "columnId": 9,
        "parentId": 0,
        "depth": 1,
        "ordinal": 217326,
        "type": "REAL",
        "childrenNode": [{
          "id": 227625,
          "name": "新增节点",
          "pathIds": "227623,227625,",
          "subjectId": 26,
          "columnId": 9,
          "parentId": 227623,
          "depth": 2,
          "ordinal": 0,
          "type": "REAL",
          "childrenNode": [{
            "id": 227626,
            "name": "新增节点",
            "pathIds": "227623,227625,227626,",
            "subjectId": 26,
            "columnId": 9,
            "parentId": 227625,
            "depth": 3,
            "ordinal": 0,
            "type": "REAL"
          }]
        }]
      }]
    }
     `
  },
  'docGetList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '文档资源', '获取文档列表'],
    title: '获取文档列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取文档列表', url: '/api/v1/invoke-v2/documents/all', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'name', type: 'String', required: '非必填', description: '检索关键字' },
        { paras: 'columnId', type: 'Int', required: '必填', description: '栏目id' },
        { paras: 'resourceDegree', type: 'Int', required: '非必填', description: '资源等级 1为免费，2为普通，3为精品' },
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科id' },
        { paras: 'versionId', type: 'Int', required: '非必填', description: '版本id' },
        { paras: 'textbookId', type: 'Int', required: '非必填', description: '册别id' },
        { paras: 'bookNodeId', type: 'Int', required: '非必填', description: '章节id/知识点id，同步备课为章节id，一轮二轮为知识点id' },
        { paras: 'documentTypeId', type: 'Int', required: '非必填', description: '文档类型id' },
        // { paras: 'gradeId', type: 'Int', required: '非必填', description: '年级id' }, // 优选卷库的
        // { paras: 'documentPaperTypeId', type: 'Int', required: '非必填', description: '文档试卷类型id' }, // 优选卷库的
        { paras: 'provinceId', type: 'Int', required: '非必填', description: '地区id' },
        { paras: 'year', type: 'Int', required: '非必填', description: '年份id' },
        { paras: 'pageNumber', type: 'Int', required: '必填', description: '页码' },
        { paras: 'pageSize', type: 'Int', required: '必填', description: '页码大小' },
        { paras: 'orderBy', type: 'String', required: '必填', description: '排序字段, updateTime最新  downloadNum下载最多 viewNum浏览最多', option: ['updateTime','downloadNum', 'viewNum'] },
        { paras: 'direction', type: 'String', required: '必填', description: '排序方式 desc倒序，asc顺序', option: ['desc','asc'] },
        // { paras: 'name', type: 'Int', required: '非必填', description: '名字' },
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: '文档id' },
        { paras: 'name ', type: 'String', description: '文档名称' },
        { paras: 'suffixType ', type: 'String', description: '文档格式' },
        { paras: 'size ', type: 'String', description: '文档大小' },
        { paras: 'author ', type: 'String', description: '文档作者' },
        { paras: 'updateTime ', type: 'String', description: '更新时间' },
        { paras: 'documentType ', type: 'Object', description: '文档类型' },
        { paras: 'bookNodes ', type: 'Object', description: '文档章节/知识点' },
        { paras: 'version ', type: 'Object', description: '文档版本' },
        { paras: 'downloadNum ', type: 'Int', description: '下载次数' },
        { paras: 'viewNum ', type: 'Int', description: '浏览次数' },
        { paras: 'stage ', type: 'Object', description: '学段' },
        { paras: 'grade ', type: 'Object', description: '年级' },
        { paras: 'subject ', type: 'Object', description: '学科' },
        { paras: 'year ', type: 'Int', description: '文档类型' },
        { paras: 'province ', type: 'String', description: '地区' },
        { paras: 'resourceDegree ', type: 'String', description: '资源等级' },
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
        "content": [{
          "id": 8904461,
          "name": "人教部编版语文一年级上册 陈敏7",
          "suffixType": "txt",
          "size": 0,
          "updateTime": "2022-11-03",
          "documentType": {
            "id": 1,
            "name": "课件"
          },
          "stage": {
            "id": 4,
            "name": "高中"
          },
          "grade": {
            "id": null,
            "name": null
          },
          "subject": {
            "id": 26,
            "name": "语文"
          },
          "version": {
            "id": 742,
            "name": "部编版",
            "bookFlag": null
          },
          "downloadNum": 24,
          "viewNum": 22,
          "province": "全国",
          "bookNodes": null,
          "origin": 2,
          "resourceDegree": 1
        }],
        "pageable": {
          "sort": {
            "sorted": true,
            "unsorted": false
          },
          "offset": 0,
          "pageNumber": 0,
          "pageSize": 10,
          "unpaged": false,
          "paged": true
        },
        "totalElements": 18,
        "totalPages": 2,
        "last": false,
        "number": 0,
        "size": 10,
        "numberOfElements": 10,
        "sort": {
          "sorted": true,
          "unsorted": false
        },
        "first": true
      }
    }
  `
  },
  'docGetInfo': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '文档资源', '查看文档详情'],
    title: '查看文档详情', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '查看文档详情', url: '/api/v1/invoke-v2/document/download', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'documentId', type: 'Int', required: '必填', description: '文档id' },
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'data ', type: 'String', description: '文档链接' },
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": "https://jty-document-new.obs.cn-north-4.myhuaweicloud.com/zipFile/20230302-1677722246417aj0ctmsdja.zip?Expires=1678353828&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=u5TTv25uTsJXLsTLs8Ns%2Bn19Kc8%3D"
    }
    `
  },
  'docGetPreview': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '文档资源', '预览文档图片'],
    title: '预览文档图片', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '查看文档详情', url: '/api/v1/invoke-v2/document/preview', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'documentId', type: 'Int', required: '必填', description: '文档id' },
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'data ', type: 'Array', description: '图片数据，zip资料长度为zip内文档数量，非zip文档长度为1，空数组表示未解压或未转码文档' },
        { paras: 'status ', type: 'String', description: '是否完成转换为图片，Finished表示完成转换，其他表示转码中' },
        { paras: 'pictureUrls ', type: 'Array', description: '文档图片地址' },
        { paras: 'picsCount ', type: 'Number', description: '文档图片总数量' },
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
          "code": 1,
          "msg": "成功",
          "data": [
              {
                  "documentId": 8906328,
                  "id": 1800,
                  "type": null,
                  "size": 1092,
                  "suffixType": "pptx",
                  "fileAddress": "{%uploaddir%}unzipFile/20230302-1677722209700l98lqdib/小学-北师大版2001二年级上册同步备课1204-01.pptx",
                  "status": "Finished",
                  "pictureUrls": [
                      "http://jty-online-preview-new.obs.cn-north-4.myhuaweicloud.com/unzipFile/20230302-1677722209700l98lqdib/%E5%B0%8F%E5%AD%A6-%E5%8C%97%E5%B8%88%E5%A4%A7%E7%89%882001%E4%BA%8C%E5%B9%B4%E7%BA%A7%E4%B8%8A%E5%86%8C%E5%90%8C%E6%AD%A5%E5%A4%87%E8%AF%BE1204-01/1.png?Expires=1684981457&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=Qg%2FYtjv4HxYr9a4JEWl8Akskizw%3D",
                      "http://jty-online-preview-new.obs.cn-north-4.myhuaweicloud.com/unzipFile/20230302-1677722209700l98lqdib/%E5%B0%8F%E5%AD%A6-%E5%8C%97%E5%B8%88%E5%A4%A7%E7%89%882001%E4%BA%8C%E5%B9%B4%E7%BA%A7%E4%B8%8A%E5%86%8C%E5%90%8C%E6%AD%A5%E5%A4%87%E8%AF%BE1204-01/2.png?Expires=1684981457&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=OzkFfPdEYT5nx4mOO8uAdh6Beog%3D",
                      "http://jty-online-preview-new.obs.cn-north-4.myhuaweicloud.com/unzipFile/20230302-1677722209700l98lqdib/%E5%B0%8F%E5%AD%A6-%E5%8C%97%E5%B8%88%E5%A4%A7%E7%89%882001%E4%BA%8C%E5%B9%B4%E7%BA%A7%E4%B8%8A%E5%86%8C%E5%90%8C%E6%AD%A5%E5%A4%87%E8%AF%BE1204-01/3.png?Expires=1684981457&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=TAkJCUfggK66rI1DHFiHPlD3JzM%3D"
                  ],
                  "isAllPics": false,
                  "picsCount": 42
              },
              {
                  "documentId": 8906328,
                  "id": 1801,
                  "type": null,
                  "size": 10,
                  "suffixType": "doc",
                  "fileAddress": "{%uploaddir%}unzipFile/20230302-1677722209700l98lqdib/优选卷库测试122数据.doc",
                  "status": "Finished",
                  "pictureUrls": [],
                  "isAllPics": false,
                  "picsCount": 1
              },
              {
                  "documentId": 8906328,
                  "id": 1802,
                  "type": null,
                  "size": 267,
                  "suffixType": "pptx",
                  "fileAddress": "{%uploaddir%}unzipFile/20230302-1677722209700l98lqdib/专训卷八.pptx",
                  "status": "Finished",
                  "pictureUrls": [
                      "http://jty-online-preview-new.obs.cn-north-4.myhuaweicloud.com/unzipFile/20230302-1677722209700l98lqdib/%E4%B8%93%E8%AE%AD%E5%8D%B7%E5%85%AB/1.png?Expires=1684981458&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=73OLPg45W61KC1p41KUOeS14pJo%3D",
                      "http://jty-online-preview-new.obs.cn-north-4.myhuaweicloud.com/unzipFile/20230302-1677722209700l98lqdib/%E4%B8%93%E8%AE%AD%E5%8D%B7%E5%85%AB/2.png?Expires=1684981458&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=BA0RH6OCPIOV7Bmx6gZqel1sOFQ%3D",
                      "http://jty-online-preview-new.obs.cn-north-4.myhuaweicloud.com/unzipFile/20230302-1677722209700l98lqdib/%E4%B8%93%E8%AE%AD%E5%8D%B7%E5%85%AB/3.png?Expires=1684981458&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=pM3yrb55pl3V6AlyKh9kKKN3lIs%3D"
                  ],
                  "isAllPics": false,
                  "picsCount": 28
              }
          ]
      }
    `
  },
  // 试卷资源
  'paperColumnList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '试卷资源', '获取试卷栏目'],
    title: '获取试卷栏目', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取试卷栏目', url: '/api/v1/invoke-v2/paper/column', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'stageId', type: 'Int', required: '必填', description: '学段id' },
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '试卷栏目id' },
        { paras: 'name', type: 'String', description: '试卷栏目name' },
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 1,
        "name": "同步专区"
      }, {
        "id": 2,
        "name": "高考专区"
      }, {
        "id": 9,
        "name": "名校专区"
      }]
    }
    `
  },
  'paperTypeList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '试卷资源', '获取试卷类型'],
    title: '获取试卷类型', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取试卷类型', url: '/api/v1/invoke-v2/paper/types', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'columnId', type: 'Int', required: '必填', description: '试卷栏目id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '试卷类型id' },
        { paras: 'name', type: 'String', description: '试卷类型名称' },
        { paras: 'shortName', type: 'String', description: '试卷类型别名' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 1,
        "name": "周测卷",
        "shortName": "周测卷"
      }, {
        "id": 2,
        "name": "单元卷",
        "shortName": "单元测试卷"
      }, {
        "id": 3,
        "name": "月考卷",
        "shortName": null
      }, {
        "id": 4,
        "name": "期中卷",
        "shortName": null
      }, {
        "id": 5,
        "name": "期末卷",
        "shortName": null
      }, {
        "id": 6,
        "name": "开学考试卷",
        "shortName": null
      }, {
        "id": 10,
        "name": "学考卷",
        "shortName": null
      }]
    }
    `
  },
  'paperVersionList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '文档资源', '获取试卷版本'],
    title: '获取试卷版本', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取试卷版本', url: '/api/v1/invoke-v2/paper/versions', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科id' },
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '版本id' },
        { paras: 'name', type: 'String', description: '版本名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 742,
        "name": "统编版",
        "bookFlag": 1
      }, {
        "id": 318,
        "name": "人教版",
        "bookFlag": 0
      }, {
        "id": 313,
        "name": "北师大版",
        "bookFlag": 0
      }, {
        "id": 314,
        "name": "华东师大版",
        "bookFlag": 0
      }, {
        "id": 322,
        "name": "粤教版",
        "bookFlag": 0
      }, {
        "id": 320,
        "name": "苏教版",
        "bookFlag": 0
      }, {
        "id": 321,
        "name": "语文版",
        "bookFlag": 0
      }]
    }
    `
  },
  'paperTextbookList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '文档资源', '获取试卷册别'],
    title: '获取试卷册别', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取试卷册别', url: '/api/v1/invoke-v2/paper/textbooks', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'versionId', type: 'Int', required: '必填', description: '版本id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '册别id' },
        { paras: 'name', type: 'String', description: '册别名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 798,
        "name": "必修1"
      }, {
        "id": 799,
        "name": "必修2"
      }]
    }
    `
  },
  'paperBookNodeList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '文档资源', '获取试卷章节'],
    title: '获取试卷章节', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取试卷章节', url: '/api/v1/invoke-v2/paper/bookNodes', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'textbookId', type: 'Int', required: '必填', description: '册别id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '章节id' },
        { paras: 'name', type: 'String', description: '章节名称' },
        { paras: 'pathIds', type: 'String', description: '章节路径' },
        { paras: 'textbookId', type: 'Int', description: '册别id' },
        { paras: 'children', type: 'Object', description: '子章节' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 20443,
        "name": "第一单元 家国情怀",
        "pathIds": "20443,",
        "textbookId": 798,
        "children": [{
          "id": 20444,
          "name": "1.我们对香港问题的基本立场  邓小平",
          "pathIds": "20443,20444,",
          "textbookId": 798
        }]
      }]
    }
    `
  },
  'paperknowledgeList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '试卷资源', '获取试卷知识点'],
    title: '获取试卷知识点', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取试卷知识点', url: '/api/v1/invoke-v2/paper/knowledgePoints', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '知识点id' },
        { paras: 'name', type: 'String', description: '知识点名称' },
        { paras: 'pathIds', type: 'String', description: '知识点路径' },
        { paras: 'children', type: 'Object', description: '子知识点' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 216202,
        "name": "古代诗文阅读(试卷大全)",
        "pathIds": "216202,",
        "children": [{
          "id": 216204,
          "name": "第十章 古代诗歌阅读",
          "pathIds": "216202,216204,"
        }]
      }]
    }

   `},
  'paperGetList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '试卷资源', '获取试卷列表'],
    title: '获取试卷列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取试卷列表', url: '/api/v1/invoke-v2/paper/findPapers', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'name', type: 'String', required: '非必填', description: '检索关键字' },
        // { paras: 'columnId', type: 'Int', required: '非必填', description: '试卷栏目id，注意 这个字段是限制查历史数据，取值为所选栏目id' },
        // { paras: 'newColumnId', type: 'Int', required: '必填', description: '试卷栏目id, 注意 名校专区 需要将相关 备课专区 和 中高考专区 的栏目id组合传入' },
        { paras: 'newColumnId', type: 'Int', required: '必填', description: '试卷栏目id' },
        { paras: 'stageId', type: 'Int', required: '必填', description: '学段id' },
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科id' },
        { paras: 'gradeId', type: 'Int', required: '非必填', description: '年级d' },
        { paras: 'versionId', type: 'Int', required: '非必填', description: '版本id' },
        { paras: 'textbookId', type: 'Int', required: '非必填', description: '册别id' },
        { paras: 'bookNodeId', type: 'Int', required: '非必填', description: '章节id/知识点id， 同步专区为章节id，中高考专区为知识点id' },
        { paras: 'paperTypeId', type: 'String', required: '必填', description: '试卷类型id， 多个类型用,隔开' },
        { paras: 'provinceId', type: 'Int', required: '非必填', description: '地区id' },
        { paras: 'year', type: 'Int', required: '非必填', description: '年份id' },
        { paras: 'pageNumber', type: 'Int', required: '必填', description: '页码' },
        { paras: 'pageSize', type: 'Int', required: '必填', description: '页码大小' },
        { paras: 'orderBy', type: 'String', required: '必填', description: '排序字段, updateTime最新  downloadNum下载最多 viewNum浏览最多', option: ['updateTime','downloadNum', 'viewNum'] },
        { paras: 'direction', type: 'String', required: '必填', description: '排序方式 desc倒序，asc顺序', option: ['desc','asc'] },
        // { paras: 'name', type: 'Int', required: '非必填', description: '名字' },
        { paras: 'range', type: 'String', required: '非必填', description: '范围， 取值为 统考，校考，联考' },
        { paras: 'suffixType', type: 'String', required: '非必填', description: '试卷格式，取值为 doc，pdf，zip' },
        { paras: 'isAnalysis', type: 'Int', required: '非必填', description: '是否有解析, 1有，空字符串为无' },
        { paras: 'isListen', type: 'Int', required: '非必填', description: '是否有听力，适合英语学科试题, 1有，空字符串为无' },
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: '试卷id' },
        { paras: 'name ', type: 'String', description: '试卷名称' },
        { paras: 'suffixType ', type: 'String', description: '试卷格式' },
        { paras: 'size ', type: 'String', description: '试卷大小' },
        { paras: 'author ', type: 'String', description: '试卷作者' },
        { paras: 'updateTime ', type: 'String', description: '更新时间' },
        { paras: 'documentType ', type: 'Object', description: '试卷类型' },
        { paras: 'version ', type: 'Object', description: '试卷版本' },
        { paras: 'downloadNum ', type: 'Int', description: '下载次数' },
        { paras: 'viewNum ', type: 'Int', description: '浏览次数' },
        { paras: 'stage ', type: 'Object', description: '学段' },
        { paras: 'grade ', type: 'Object', description: '年级' },
        { paras: 'subject ', type: 'Object', description: '学科' },
        { paras: 'year ', type: 'Int', description: '试卷类型' },
        { paras: 'scope ', type: 'Object', description: '试卷范围' },
        { paras: 'isAnalysis ', type: 'Int', description: '是否包含解析' },
        { paras: 'isListen ', type: 'Int', description: '是否包含听力' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
        "content": [{
          "id": 8906097,
          "fileAddress": "{%uploaddir%}2022/12/26/1672041805258h6uej94dt8.doc",
          "name": "高中语文高考专区周测卷人教版第十一章 名句名篇默写",
          "suffixType": "doc",
          "size": 13,
          "author": "cm",
          "updateTime": "2022-12-26",
          "modifiedTime": "2022-12-26",
          "documentType": {
            "id": 3,
            "name": "习题/作业"
          },
          "version": {
            "id": 318,
            "name": "人教版",
            "bookFlag": null
          },
          "downloadNum": 20,
          "viewNum": 17,
          "fabulousNum": 0,
          "collected": false,
          "thumbs": false,
          "downloadIntegral": 0,
          "isDownload": false,
          "stage": {
            "id": 4,
            "name": "高中"
          },
          "grade": {
            "id": null,
            "name": null
          },
          "subject": {
            "id": 26,
            "name": "语文"
          },
          "documentPaperType": {
            "id": null,
            "name": null
          },
          "nrscSourceDto": null,
          "columnName": null,
          "year": "2023",
          "scoreUserNum": null,
          "avgScore": null,
          "myScore": null,
          "pics": null,
          "picsCount": null,
          "isAllPics": null,
          "resourceDegree": 1,
          "filePath": null,
          "isAnalysis": 0,
          "scope": "默认",
          "isListen": 0
        }],
        "pageable": {
          "sort": {
            "sorted": true,
            "unsorted": false
          },
          "offset": 0,
          "pageNumber": 0,
          "pageSize": 10,
          "unpaged": false,
          "paged": true
        },
        "totalElements": 18,
        "totalPages": 2,
        "last": false,
        "number": 0,
        "size": 10,
        "numberOfElements": 10,
        "sort": {
          "sorted": true,
          "unsorted": false
        },
        "first": true
      }
    }

  `
  },
  'paperGetInfo': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '试卷资源', '查看试卷详情'],
    title: '查看试卷详情', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '查看试卷详情', url: '/api/v1/invoke-v2/paper/paperDownload', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'paperId', type: 'Int', required: '必填', description: '试卷id' },

      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'data', type: 'String', required: '必填', description: '试卷url' },
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": "https://jty-document-new.obs.cn-north-4.myhuaweicloud.com/2022/12/26/1672041805258h6uej94dt8.doc?Expires=1678602377&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=%2FLNHDV8nRzh1jwB9W4Wnv7jfln8%3D&response-content-disposition=%20attachment%3B%20filename%3D%22%C3%A9%C2%AB%C2%98%C3%A4%C2%B8%C2%AD%C3%A8%C2%AF%C2%AD%C3%A6%C2%96%C2%87%C3%A9%C2%AB%C2%98%C3%A8%C2%80%C2%83%C3%A4%C2%B8%C2%93%C3%A5%C2%8C%C2%BA%C3%A5%C2%91%C2%A8%C3%A6%C2%B5%C2%8B%C3%A5%C2%8D%C2%B7%C3%A4%C2%BA%C2%BA%C3%A6%C2%95%C2%99%C3%A7%C2%89%C2%88%C3%A7%C2%AC%C2%AC%C3%A5%C2%8D%C2%81%C3%A4%C2%B8%C2%80%C3%A7%C2%AB%C2%A0%20%C3%A5%C2%90%C2%8D%C3%A5%C2%8F%C2%A5%C3%A5%C2%90%C2%8D%C3%A7%C2%AF%C2%87%C3%A9%C2%BB%C2%98%C3%A5%C2%86%C2%99.doc%22&response-content-type=application%2Fmsword"
    } `
  },
  'paperGetPreview': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '试卷资源', '预览试卷图片'],
    title: '预览试卷图片', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '查看试卷详情', url: '/api/v1/invoke-v2/paper/preview', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'paperId', type: 'Int', required: '必填', description: '试卷id' },

      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'data ', type: 'Array', description: '图片数据，zip资料长度为zip内文档数量，非zip文档长度为1，空数组表示未解压或未转码文档' },
        { paras: 'status ', type: 'String', description: '是否完成转换为图片，Finished表示完成转换，其他表示转码中' },
        { paras: 'pictureUrls ', type: 'Array', description: '文档图片地址' },
        { paras: 'picsCount ', type: 'Number', description: '文档图片总数量' },
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [
        {
          "documentId": 9774187,
          "id": 1049972,
          "type": "document",
          "size": null,
          "suffixType": null,
          "fileAddress": "{%uploaddir%}2023/5/26/1685080357210mh2kk89i8g.docx",
          "status": "Finished",
          "pictureUrls": [
            "http://jty-online-preview-new.obs.cn-north-4.myhuaweicloud.com/2023/5/26/1685080357210mh2kk89i8g/1.png?Expires=1685099204&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=G13%2BxqAnTFlm5Dssr0VUZRhJ%2Bsw%3D",
            "http://jty-online-preview-new.obs.cn-north-4.myhuaweicloud.com/2023/5/26/1685080357210mh2kk89i8g/2.png?Expires=1685099204&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=8rOsNtL1dRS%2FsGJBhlfhzmB7B0U%3D",
            "http://jty-online-preview-new.obs.cn-north-4.myhuaweicloud.com/2023/5/26/1685080357210mh2kk89i8g/3.png?Expires=1685099204&OSSAccessKeyId=LTAI5tJ94NZBMdYjreZXXgFh&Signature=AFiKMEtYAGMrGA44ht%2Faae0aTKw%3D"
          ],
          "isAllPics": true,
          "picsCount": 10
        }
      ]
    } `
  },
  // 试题
  'questionTypeList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '试题资源', '获取试题题型'],
    title: '获取试题类型', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取试题类型', url: '/api/v1/invoke-v2/questionV3/questionTypes', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科Id' },

      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: '试题类型id' },
        { paras: 'name ', type: 'String', description: '试题类型name' },
        { paras: 'isSelectType ', type: 'Boolean', description: '是否为选择题组' },
        { paras: 'ordinal ', type: 'Int', description: '排序值' },
        { paras: 'used ', type: 'Boolean', description: '是否使用' },
        { paras: 'subjectId ', type: 'Int', description: '学科id' },
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 17,
        "name": "选择题",
        "isSelectType": true,
        "ordinal": 1,
        "used": null,
        "subjectId": 26
      }]
    } `
  },
  'questionDifficultList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '试题资源', '获取试题难度'],
    title: '获取试题难度', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取试题难度', url: '/api/v1/invoke-v2/questionV3/difficultType', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: '无', type: '无', required: '无', description: '无' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '试题难度id' },
        { paras: 'stem', type: 'String', description: '试题难度name' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 1,
        "name": "容易"
      }, {
        "id": 2,
        "name": "较易"
      }, {
        "id": 3,
        "name": "一般"
      }, {
        "id": 4,
        "name": "较难"
      }, {
        "id": 5,
        "name": "困难"
      }]
    }
    `
  },
  'questionVersionList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '试题资源', '获取试题版本'],
    title: '获取版本列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取试题版本', url: '/api/v1/invoke-v2/questionV3/questionVersions', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科id' },
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '版本id' },
        { paras: 'name', type: 'String', description: '版本名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 230,
        "name": "统编版",
        "bookFlag": null
      }, {
        "id": 231,
        "name": "人教版",
        "bookFlag": null
      }]
    }
    `
  },
  'questionTextbookList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '试题资源', '获取试题册别'],
    title: '获取试题册别', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取试题册别', url: '/api/v1/invoke-v2/questionV3/questionTextbooks', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'versionId', type: 'Int', required: '必填', description: '版本id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '册别id' },
        { paras: 'name', type: 'String', description: '册别名称' },
        { paras: 'ordinal', type: 'Int', description: '排序值' }
      ]
    },
    showResponseCode: true,
    responseCode: `{
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 1609,
        "name": "必修上册",
        "description": null,
        "ordinal": 37,
        "used": null,
        "versionId": 230
      }]
    }`
  },
  'questionBooknodeList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '试题资源', '获取试题章节'],
    title: '获取试题章节', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '200px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '400px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取试题章节', url: '/api/v1/invoke-v2/questionV3/questionBookNodes', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'textbookId', type: 'Int', required: '必填', description: '册别id' },

      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: 'id' },
        { paras: 'name', type: 'String', description: '章节name' },
        { paras: 'pathIds', type: 'String', description: '章节层级路径' },
        { paras: 'textbookId', type: 'Int', description: '册别id' },
        { paras: 'children', type: 'Object', description: '子章节' },
      ]
    },
    showKeyIntroduct: false, // 是否显示字段解释
    showResponseCode: true,
    responseCode: `{
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 92135,
        "name": "第一单元",
        "pathIds": "92135,",
        "textbookId": 1609,
        "children": [{
          "id": 92136,
          "name": "1 沁园春•长沙",
          "pathIds": "92135,92136,",
          "textbookId": 1609
        }]
      }]
    }`
  },
  'questionKnowledgeList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '试题资源', '获取试题知识点'],
    title: '获取试题知识点', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取试题知识点', url: '/api/v1/invoke-v2/questionV3/questionKnowledgePoints', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '知识点id' },
        { paras: 'name', type: 'String', description: '知识点名称' },
        { paras: 'pathIds', type: 'String', description: '知识点层级路径' },
        { paras: 'subjectId', type: 'Int', description: '学科id' },
        { paras: 'children', type: 'Object', description: '子知识点' }
      ]
    },
    showResponseCode: true,
    responseCode: ` {
      "code": 1,
      "msg": "成功",
      "data": [{
        "id": 9632,
        "name": "语言文字运用",
        "pathIds": "9632,",
        "children": [{
          "id": 9633,
          "name": "汉字",
          "pathIds": "9632,9633,",
          "children": [{
            "id": 9634,
            "name": "字音",
            "pathIds": "9632,9633,9634,"
          }]
        }]
      }]
    }`
  },
  'questionGetList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '试题资源', '获取试题列表'],
    title: '获取试题列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取试题列表', url: '/api/v1/invoke-v2/questionV3/all', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'keyword', type: 'String', required: '非必填', description: '检索关键字' },
        { paras: 'stageId', type: 'Int', required: '必填', description: '学段Id' },
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科Id' },
        // { paras: 'versionId', type: 'Int', required: '非必填', description: '版本Id' },
        { paras: 'textbookId', type: 'Int', required: '非必填', description: '册别Id' },
        { paras: 'searchType', type: 'String', required: '必填', description: '搜索类型 knowledgePoint 为知识点选题，booknode 为章节选题##章节选题textbookId为必填项 ', option: ['knowledgePoint','booknode'] },
        { paras: 'knowledgePointId', type: 'Int', required: '非必填', description: '知识点Id，多个知识点按,分割' },
        { paras: 'bookNodeId', type: 'Int', required: '非必填', description: '章节Id' },
        { paras: 'questionDifficultId', type: 'Int', required: '非必填', description: '试题难度Id' },
        { paras: 'questionTypeId', type: 'Int', required: '非必填', description: '试题类型Id, 多个题型按,分割' },
        { paras: 'provinceIds', type: 'Int', required: '非必填', description: '地区Id' },
        { paras: 'year', type: 'Int', required: '非必填', description: '年份' },
        { paras: 'pageNumber', type: 'Int', required: '必填', description: '页码' },
        { paras: 'pageSize', type: 'Int', required: '必填', description: '页码大小' },
        { paras: 'orderBy', type: 'String', required: '必填', description: '排序字段 updateTime为按时间排序 zuJuanCount 为组卷次数', option: ['updateTime','zuJuanCount'] },
        { paras: 'direction', type: 'String', required: '必填', description: '排序方式 desc倒序，asc顺序', option: ['desc','asc'] },
        { paras: 'versionId', type: 'String', required: '非必填', description: '试题版本' },
        // { paras: 'direction', type: 'String', required: '必填', description: '排序方式 desc倒序，asc顺序',option: ['desc','asc'] },
        // { paras: 'direction', type: 'String', required: '必填', description: '排序方式 desc倒序，asc顺序',option: ['desc','asc'] },
        // { paras: 'direction', type: 'String', required: '必填', description: '排序方式 desc倒序，asc顺序',option: ['desc','asc'] },
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: '试题id' },
        { paras: 'stem', type: 'String', description: '题干' },
        { paras: 'options', type: 'String', description: '选项' },
        { paras: 'difficult', type: 'Object', description: '题目难度系数' },
        { paras: 'type', type: 'Object', description: '题目类型' },
        { paras: 'updateTime', type: 'String', description: '更新时间' },
        { paras: 'children', type: 'Object', description: '子题集合' },
        { paras: 'isCollection', type: 'Boolean', description: '是否收藏(扩展字段)' },
        { paras: 'zuJuanCount', type: 'Int', description: '组卷次数(扩展字段)' },
        { paras: 'origin', type: 'Int', description: '资源类型标识(0:普通，非0:精品)' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
        "content": [{
            "id": 201551567,
            "stem": "<p style=\"vertical-align: middle; margin-top: 0pt; margin-bottom: 0pt; line-height: 150%; widows: 0; orphans: 0;\">已知集合<img style=\"vertical-align: middle; -aw-left-pos: 0pt; -aw-rel-hpos: column; -aw-rel-vpos: paragraph; -aw-top-pos: 0pt; -aw-wrap-type: inline;\" src=\"http://jty-question-document-v3-image.oss-cn-zhangjiakou.aliyuncs.com/images/2023/2023-2-28/167759030848060449843.png\" width=\"267\" height=\"30\" />，则<img style=\"vertical-align: middle; -aw-left-pos: 0pt; -aw-rel-hpos: column; -aw-rel-vpos: paragraph; -aw-top-pos: 0pt; -aw-wrap-type: inline;\" src=\"http://jty-question-document-v3-image.oss-cn-zhangjiakou.aliyuncs.com/images/2023/2023-2-28/167759030875730203400.png\" width=\"55\" height=\"21\" />（<span style=\"-aw-import: spaces;\">&nbsp;&nbsp;&nbsp; </span>）</p>",
            "options": {
              "A": "/span&gt;<img style=\"vertical-align: middle; -aw-left-pos: 0pt; -aw-rel-hpos: column; -aw-rel-vpos: paragraph; -aw-top-pos: 0pt; -aw-wrap-type: inline;\" src=\"http://jty-question-document-v3-image.oss-cn-zhangjiakou.aliyuncs.com/images/2023/2023-2-28/167759030896912805600.png\" width=\"37\" height=\"28\" />",
              "B": "</span><img src=\"http://jty-question-document-v3-image.oss-cn-zhangjiakou.aliyuncs.com/images/2023/2023-2-28/167759030974704395964.png\" width=\"47\" height=\"28\"  style=\"vertical-align: middle; -aw-left-pos: 0pt; -aw-rel-hpos: column; -aw-rel-vpos: paragraph; -aw-top-pos: 0pt; -aw-wrap-type: inline;\">",
              "C": "</span><img src=\"http://jty-question-document-v3-image.oss-cn-zhangjiakou.aliyuncs.com/images/2023/2023-2-28/167759030984944120618.png\" width=\"70\" height=\"27\"  style=\"vertical-align: middle; -aw-left-pos: 0pt; -aw-rel-hpos: column; -aw-rel-vpos: paragraph; -aw-top-pos: 0pt; -aw-wrap-type: inline;\">",
              "D": "</span><img src=\"http://jty-question-document-v3-image.oss-cn-zhangjiakou.aliyuncs.com/images/2023/2023-2-28/167759031004943709797.png\" width=\"82\" height=\"28\"  style=\"vertical-align: middle; -aw-left-pos: 0pt; -aw-rel-hpos: column; -aw-rel-vpos: paragraph; -aw-top-pos: 0pt; -aw-wrap-type: inline;\">"
            },
            "difficult": {
              "id": 1,
              "name": "容易"
            },
            "type": {
              "id": 17,
              "name": "选择题",
              "isSelectType": true
            },
            "updateTime": "2023-02-28T13:54:12",
            "children": [],
            "isCollection": false,
            "zuJuanCount": 34,
            "origin": 1,
            "paperApiDto": {
              "id": 1000158,
              "name": "0223试题",
              "ordinal": 1
            },
            "knowledgePoints": [],
            "listeningFileAddress": null,
            "comment": null,
            "testPoint": null,
            "method": null,
            "questionCommonType": null,
            "subject": null,
            "grade": null,
            "knowledgePointCount": null,
            "sourceId": null,
            "sourceName": null,
            "sourceType": null,
            "status": null,
            "schoolId": null,
            "uid": null,
            "bookNodes": [{
              "id": 92136,
              "name": "1 沁园春•长沙",
              "pathIds": "92135,92136,",
              "textbookId": 1609
            }],
            "childrenList": [],
            "papers": [{
              "id": 1000158,
              "name": "0223试题",
              "ordinal": 1
            }],
            "answer": null,
            "analysis": null,
            "resourceNodes": null,
            "version": null,
            "ordinal": null,
            "includeVideo": false,
            "includeAnalysis": false
          }
        }
      }


  `
  },
  'questionGetInfo': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '试题资源', '查看试题详情'],
    title: '查看试题详情', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '查看试题详情', url: '/api/v1/invoke-v2/questionV3/questionDetails', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'questionId', type: 'Int', required: '必填', description: '题目id' },
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: 'id' },
        { paras: 'stem', type: 'String', description: '题干' },
        { paras: 'options', type: 'String', description: '选项' },
        { paras: 'difficult', type: 'Object', description: '题目难度' },
        { paras: 'type', type: 'Object', description: '题目类型' },
        { paras: 'updateTime', type: 'String', description: '更新时间' },
        { paras: 'answer', type: 'String', description: '答案' },
        { paras: 'labelAnswer', type: 'String', description: '标签' },
        { paras: 'analysis', type: 'String', description: '解析' },
        { paras: 'method', type: 'String', description: '分析' },
        { paras: 'children', type: 'Array', description: '子题集合' },
        { paras: 'bookNodes', type: 'Array', description: '章节集合' },
        { paras: 'knowlegePoints', type: 'Array', description: '知识点集合' },
        { paras: 'listeningFileAddress', type: 'String', description: '听力文件' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
      "code": 1,
      "msg": "成功",
      "data": {
        "id": 200000008,
        "stem": "已知集合A={0，m，m<sup>2</sup>-3m+2}，且2∈A，则实数m为（　　）",
        "options": {
          "A": "2",
          "B": "3",
          "C": "0或3",
          "D": "0，2，3均可"
        },
        "difficult": {
          "id": 1,
          "name": "容易"
        },
        "type": {
          "id": 34,
          "name": "选择题",
          "isSelectType": null
        },
        "updateTime": "2013-11-25T00:00:00",
        "answer": "B",
        "labelAnswer": null,
        "analysis": "",
        "comment": "",
        "testPoint": null,
        "method": "",
        "children": [],
        "bookNodes": null,
        "knowledgePoints": [{
          "id": 2422,
          "name": "元素与集合关系的判断",
          "pathIds": "2418,2419,2420,2422,",
          "subjectId": 27
        }],
        "listeningFileAddress": null
      }
    }
  `
  },
  // 微课
  'microSubjectList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '视频资源', '获取微课学科列表'],
    title: '获取微课学科列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取微课学科列表', url: '/api/v1/invoke/microLesson/subjects', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'stageId', type: 'Int', required: '必填', description: '学段id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '学科id' },
        { paras: 'name', type: 'String', description: '学科名称' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
          "code": 1,
          "msg": "成功",
          "data": [
               {
                  "id": 15,
                  "name": "语文"
              },
              {
                  "id": 13,
                  "name": "数学"
              }
           ]
      }
    `
  },
  'microKnowList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '视频资源', '获取微课知识点'],
    title: '获取微课知识点', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取微课知识点列表', url: '/api/v1/invoke/microLesson/knowledgePoints', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'subjectId', type: 'Int', required: '必填', description: '学科id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id', type: 'Int', description: '知识点id' },
        { paras: 'name', type: 'String', description: '知识点名称' },
        { paras: 'pathIds', type: 'String', description: '路径' },
        { paras: 'subjectId', type: 'Int', description: '学科id' },
        { paras: 'knowledgePointChildren', type: 'Object', description: '知识点子集合' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
          "code": 1,
          "msg": "成功",
          "data": [
               {
                  "id": 53,
                  "name": "汉语拼音",
                  "pathIds": "53",
                  "subjectId": 3,
                  "knowledgePointChildren": null
              },
              {
                  "id": 54,
                  "name": "识字与写字",
                  "pathIds": "54",
                  "subjectId": 3,
                  "knowledgePointChildren": null
              },
           ]
      }
    `
  },
  'microGetList': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '视频资源', '获取微课列表'],
    title: '获取微课列表', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取微课列表', url: '/api/v1/invoke/videos', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'subjectCategoryType', type: 'Iteger', required: '非必填', description: '学科类别id' },
        { paras: 'subjectId', type: 'Iteger', required: '必填', description: '学科id' },
        { paras: 'knowledgePointId', type: 'Iteger', required: '非必填', description: '知识点id' },
        { paras: 'pageNumber', type: 'Iteger', required: '必填', description: '页数' },
        { paras: 'pageSize', type: 'Iteger', required: '必填', description: '每页条数' },
        { paras: 'name', type: 'String', required: '非必填', description: '视频名称' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: 'id' },
        { paras: 'code', type: 'String', description: '阿里云id' },
        { paras: 'uploadTime', type: 'LocalDateTime', description: '上传时间' },
        { paras: 'title', type: 'Sring', description: '视频标题' },
        { paras: 'coverUrl', type: 'String', description: '视频封面' },
        { paras: 'stageId', type: 'Int', description: '学段id' },
        { paras: 'gradeId', type: 'Int', description: '年级id' },
        { paras: 'subjectId', type: 'Int', description: '学科id' },
        { paras: 'source', type: 'String', description: '来源' },
        { paras: 'version', type: 'String', description: '版本' },
        { paras: 'totalPages ', type: 'Int', description: '总页数' },
        { paras: 'totalElements ', type: 'Int', description: '总数' },
        { paras: 'numberOfElements ', type: 'Int', description: '每页显示条数' },
        { paras: 'sort ', type: 'Object', description: '排序' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
          "code": 1,
          "msg": "成功",
          "data": {
              "content": [
                  {
                      "id": 11,
                      "code": "c2cd959d27064551a051008f75cd6c0a",
                      "uploadTime": "2020-03-12",
                      "title": "用字母表示数",
                      "coverUrl": "https://video.jtyjy.com/c2cd959d27064551a051008f75cd6c0a/snapshots/288f9bbb82dc4356aa468c481a874d90-00005.jpg",
                      "stageId": 2,
                      "gradeId": 2,
                      "subjectId": 1,
                      "source": "苏州国际外语学校",
                      "version": "人教版"
                  }
             ],
              "pageable": {
                  "sort": {
                      "sorted": true,
                      "unsorted": false
                  },
                  "offset": 0,
                  "pageSize": 20,
                  "pageNumber": 0,
                  "paged": true,
                  "unpaged": false
              },
              "totalElements": 2611,
              "totalPages": 131,
              "last": false,
              "number": 0,
              "size": 20,
              "sort": {
                  "sorted": true,
                  "unsorted": false
              },
              "numberOfElements": 20,
              "first": true
          }
      }
    `
  },
  'microPlayCode': {
    showBreadcrumnb: true,
    breadcrumnbList: ['全部文档', 'API文档', '视频资源', '获取微课播放授权码'],
    title: '获取微课播放授权码', // 标题
    showInterfaceInfo: true, // 是否显示基础接口表格
    interfaceInfoTable: {
      tableHead: [{
        prop: 'desc',
        align: 'center',
        label: '接口描述',
        width: '240px'
      },
      {
        prop: 'url',
        align: 'center',
        label: '接口地址',
        width: '360px'
      },
      {
        prop: 'way',
        align: 'center',
        label: '请求方式'
      },
      {
        prop: 'parttern',
        align: 'center',
        label: '返回格式'
      }],
      tableData: [
        { desc: '获取微课播放授权码', url: '/api/v1/invoke/media/play', way: 'GET', parttern: 'JSON' }
      ]
    },
    showRequestHeadParams: true, // 是否显示头部请求参数表格
    requestHeadParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'Authorization', type: 'String', required: '必填', description: '请求令牌' },
        { paras: 'Content-Type', type: 'String', required: '必填', description: 'json 格式化请求' },
        { paras: 'accesskey', type: 'String', required: '必填', description: '开发者注册成功获取的ClientId' },
        { paras: 'timestamp', type: 'String', required: '必填', description: '时间戳' },
        { paras: 'nonce', type: 'String', required: '必填', description: '随机数' },
        { paras: 'sign', type: 'String', required: '必填', description: 'descriptionSign' }
      ]
    },
    showYWRequestParamsTable: true, // 是否显示业务请求参数
    yWRequestParamsTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '16%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'required',
        minWidth: '24%',
        align: 'center',
        label: '是否必填'
      },
      {
        prop: 'description',
        minWidth: '60%',
        label: '描述'
      }],
      tableData: [
        { paras: 'videoId', type: 'Iteger', required: '必填', description: '微课id' }
      ]
    },
    showResponseTable: true, // 是否显示响应参数表格
    responseTable: {
      tableHead: [{
        prop: 'paras',
        width: '250px',
        align: 'center',
        label: '参数'
      },
      {
        prop: 'type',
        width: '122px',
        minWidth: '20%',
        align: 'center',
        label: '类型'
      },
      {
        prop: 'description',
        minWidth: '80%',
        label: '说明'
      }],
      tableData: [
        { paras: 'id ', type: 'Int', description: 'id' },
        { paras: 'code', type: 'String', description: '阿里云id' },
        { paras: 'uploadTime', type: 'LocalDateTime', description: '上传时间' },
        { paras: 'title', type: 'String', description: '视频标题' },
        { paras: 'coverUrl', type: 'String', description: '视频封面' },
        { paras: 'source', type: 'String', description: '来源' },
        { paras: 'duration', type: 'String', description: '时长' },
        { paras: 'playAuth', type: 'String', description: '播放视频授权码' }
      ]
    },
    showResponseCode: true,
    responseCode: `
    {
          "code": 1,
          "msg": "成功",
          "data": {
              "playAuth": "eyJTZWN1cml0eVRva2VuIjoiQ0FJU2h3TjFxNkZ0NUIyeWZTaklyNWZHRS83T2pwZE84YW1FTkVubWxqY0NUYzFQbmZmaHR6ejJJSGxQZTNGaEFPb2V2L2svbVc5VTdmb2Nsck1xRnNNZUdCQ2JNcE12c01vSnJsN3dKcExGc3QySjZyOEpqc1UxaElsdnVsaXBzdlhKYXNEVkVmbDJFNVhFTWlJUi8wMGU2TC8rY2lyWXBUWEhWYlNDbFo5Z2FQa09Rd0M4ZGtBb0xkeEtKd3hrMnQxNFVtWFdPYVNDUHdMU2htUEJMVXhtdldnR2wyUnp1NHV5M3ZPZDVoZlpwMXI4eE80YXhlTDBQb1AyVjgxbExacGxlc3FwM0k0U2M3YmFnaFpVNGdscjhxbHg3c3BCNVN5Vmt0eVdHVWhKL3phTElvaXQ3TnBqZmlCMGVvUUFQb3BGcC9YNmp2QWF3UExVbTliWXhncGhCOFIrWGo3RFpZYXV4N0d6ZW9XVE84MCthS3p3TmxuVXo5bUxMZU9WaVE0L1ptOEJQdzQ0RUxoSWFGMElVRUo4RzJDQ2QvWDRvZ3VTT2xuOUVKTG9pdjltamNCSHFIeno1c2VQS2xTMVJMR1U3RDBWSUpkVWJUbHpia1ZKaFQyNEtQZFhMbHdSTEE4OFcraVBNYXgzYlFGRHI1M3ZzVGJiWHpaYjBtcHR1UG56ZDJ4MkJCT3NuMjJVR29BQk80YmRGbW54Y25aRHd1bjEyak9lQmRQSmkyWUQ5RW8wQ2tnUnUwYmpTVVQ1YzZRS0d3QjZnQkFVYXY4TXJBd3NZUFRLTlppMlI2eGRuU1c0WU1uMG5IeEFSajJlSDdUcHJVNXRWK1BHK1haZzRuQStLYzFPcm5CbkZmbE5sL21VVGJJMmxQcFFTT2JhVDNIcWtpQjZrKzFZbGVOa0dRUFdWTHMrR3FnRyszdz0iLCJBdXRoSW5mbyI6IntcIkNJXCI6XCI4eXQ5aFkwVTAxcVVwODB1MDdGME55a3ZrUk1VSVlQOWhyeWNiSEZJNVVMUGFXYXliYytQTW1LdVE2SUFsSk1HXCIsXCJDYWxsZXJcIjpcIjY2S3licDhkU3hrdDJlcDUwMFR6c2ZOSmRmdndFRHpsVG5RcEo1aUJhTlk9XCIsXCJFeHBpcmVUaW1lXCI6XCIyMDIwLTExLTA0VDA4OjE2OjE4WlwiLFwiTWVkaWFJZFwiOlwiYzJjZDk1OWQyNzA2NDU1MWEwNTEwMDhmNzVjZDZjMGFcIixcIlBsYXlEb21haW5cIjpcInZpZGVvLmp0eWVkdS5jb21cIixcIlNpZ25hdHVyZVwiOlwiVnJ3MTgzMU1sYWw0WHJqRnVsVFhBSXB0bStRPVwifSIsIlZpZGVvTWV0YSI6eyJTdGF0dXMiOiJOb3JtYWwiLCJWaWRlb0lkIjoiYzJjZDk1OWQyNzA2NDU1MWEwNTEwMDhmNzVjZDZjMGEiLCJUaXRsZSI6IueUqOWtl+avjeihqOekuuaVsCIsIkNvdmVyVVJMIjoiaHR0cHM6Ly92aWRlby5qdHllZHUuY29tL2MyY2Q5NTlkMjcwNjQ1NTFhMDUxMDA4Zjc1Y2Q2YzBhL3NuYXBzaG90cy8yODhmOWJiYjgyZGM0MzU2YWE0NjhjNDgxYTg3NGQ5MC0wMDAwNS5qcGciLCJEdXJhdGlvbiI6NjQxLjkzM30sIkFjY2Vzc0tleUlkIjoiU1RTLk5Uc1hEemNIb0ZrbzZvV3I3V0FCY3IySlUiLCJQbGF5RG9tYWluIjoidmlkZW8uanR5ZWR1LmNvbSIsIkFjY2Vzc0tleVNlY3JldCI6IjlqUFROMWJBcnlpZUdXd2JEbm5vM0xSYUZOUVkyNlJoanV3b3dkaWZ2VmpOIiwiUmVnaW9uIjoiY24tc2hhbmdoYWkiLCJDdXN0b21lcklkIjoxNTQzNTQ3NzA3NjY2NzU5fQ==",
              "duration": 641.933,
              "title": "用字母表示数",
              "code": "c2cd959d27064551a051008f75cd6c0a",
              "coverUrl": "https://video.jtyjy.com/c2cd959d27064551a051008f75cd6c0a/snapshots/288f9bbb82dc4356aa468c481a874d90-00005.jpg",
              "source": "苏州国际外语学校",
              "id": 11
          }
      }
    `
  },
  // 精品专辑
  ...albumApiData,
  ...gardenApiData,
  ...researchApiData
}

const questionV4DocMap = {
  questionV4TypeList: ['questionTypeList', '获取questionV4试题类型', '/api/v1/invoke-v2/questionV4/questionTypes'],
  questionV4DifficultList: ['questionDifficultList', '获取questionV4试题难度', '/api/v1/invoke-v2/questionV4/difficultType'],
  questionV4VersionList: ['questionVersionList', '获取questionV4试题版本', '/api/v1/invoke-v2/questionV4/questionVersions'],
  questionV4TextbookList: ['questionTextbookList', '获取questionV4试题册别', '/api/v1/invoke-v2/questionV4/questionTextbooks'],
  questionV4BooknodeList: ['questionBooknodeList', '获取questionV4试题章节', '/api/v1/invoke-v2/questionV4/questionBookNodes'],
  questionV4KnowledgeList: ['questionKnowledgeList', '获取questionV4试题知识点', '/api/v1/invoke-v2/questionV4/questionKnowledgePoints'],
  questionV4GetList: ['questionGetList', '获取questionV4试题列表', '/api/v1/invoke-v2/questionV4/all'],
  questionV4GetInfo: ['questionGetInfo', '查看questionV4试题详情', '/api/v1/invoke-v2/questionV4/questionDetails']
}

Object.keys(questionV4DocMap).forEach(key => {
  const [sourceKey, title, url] = questionV4DocMap[key]
  const source = apiData[sourceKey]
  apiData[key] = JSON.parse(JSON.stringify(source))
  apiData[key].title = title
  apiData[key].breadcrumnbList = ['全部文档', 'API文档', 'questionV4试题资源', title]
  apiData[key].interfaceInfoTable.tableData[0].desc = title
  apiData[key].interfaceInfoTable.tableData[0].url = url
})

apiData.questionV4BooknodeList.yWRequestParamsTable.tableData = [
  { paras: 'stageId', type: 'Int', required: '必填', description: '学段Id' },
  { paras: 'subjectId', type: 'Int', required: '必填', description: '学科Id' },
  { paras: 'textbookId', type: 'Int', required: '同步章节必填', description: '册别Id，channelType=1 时必填' },
  { paras: 'channelType', type: 'Int', required: '必填', description: '章节类型，1 同步章节，2 备考章节', option: [1, 2] }
]

apiData.questionV4GetList.yWRequestParamsTable.tableData = apiData.questionV4GetList.yWRequestParamsTable.tableData
  .filter(item => item.paras !== 'orderBy')
  .concat([
    { paras: 'channelType', type: 'Int', required: '章节筛选时必填', description: '章节类型，1 同步章节，2 备考章节', option: [1, 2] },
    { paras: 'tag', type: 'String', required: '非必填', description: '学科特色标签Id，多个按英文逗号分隔' },
    { paras: 'paperCategoryId', type: 'Int', required: '非必填', description: '来源Id，通过 questionV4 试题来源接口获取' },
    { paras: 'union', type: 'Int', required: '非必填', description: '仅知识点筛选生效，1 包含任意知识点，0 包含所有知识点，默认 1', option: [1, 0] },
    { paras: 'orderBy', type: 'String', required: '必填', description: '排序字段，目前支持 updateTime 按时间排序', option: ['updateTime'] }
  ])

apiData.questionV4TagTypeList = JSON.parse(JSON.stringify(apiData.questionTypeList))
apiData.questionV4TagTypeList.title = '获取questionV4学科特色标签类型'
apiData.questionV4TagTypeList.breadcrumnbList = ['全部文档', 'API文档', 'questionV4试题资源', '获取questionV4学科特色标签类型']
apiData.questionV4TagTypeList.interfaceInfoTable.tableData[0] = {
  desc: '获取questionV4学科特色标签类型',
  url: '/api/v1/invoke-v2/questionV4/questionTagTypes',
  way: 'GET',
  parttern: 'JSON'
}
apiData.questionV4TagTypeList.yWRequestParamsTable.tableData = [
  { paras: 'subjectId', type: 'Int', required: '必填', description: '学科Id' }
]
apiData.questionV4TagTypeList.responseTable.tableData = [
  { paras: 'id', type: 'Int', description: '标签类型Id' },
  { paras: 'name', type: 'String', description: '标签类型名称' },
  { paras: 'ordinal', type: 'Int', description: '排序值' },
  { paras: 'subjectId', type: 'Int', description: '学科Id' },
  { paras: 'stageId', type: 'Int', description: '学段Id' }
]

apiData.questionV4TagList = JSON.parse(JSON.stringify(apiData.questionV4TagTypeList))
apiData.questionV4TagList.title = '获取questionV4学科特色标签'
apiData.questionV4TagList.breadcrumnbList = ['全部文档', 'API文档', 'questionV4试题资源', '获取questionV4学科特色标签']
apiData.questionV4TagList.interfaceInfoTable.tableData[0] = {
  desc: '获取questionV4学科特色标签',
  url: '/api/v1/invoke-v2/questionV4/questionTags',
  way: 'GET',
  parttern: 'JSON'
}
apiData.questionV4TagList.yWRequestParamsTable.tableData = [
  { paras: 'subjectId', type: 'Int', required: '必填', description: '学科Id' },
  { paras: 'typeId', type: 'Int', required: '必填', description: '标签类型Id' }
]
apiData.questionV4TagList.responseTable.tableData = [
  { paras: 'id', type: 'Int', description: '标签Id' },
  { paras: 'name', type: 'String', description: '标签名称' },
  { paras: 'parentId', type: 'Int', description: '父级标签Id' },
  { paras: 'pathIds', type: 'String', description: '层级路径' },
  { paras: 'children', type: 'Array', description: '子标签集合' }
]

apiData.questionV4PaperTypeList = JSON.parse(JSON.stringify(apiData.questionV4TagTypeList))
apiData.questionV4PaperTypeList.title = '获取questionV4试题来源'
apiData.questionV4PaperTypeList.breadcrumnbList = ['全部文档', 'API文档', 'questionV4试题资源', '获取questionV4试题来源']
apiData.questionV4PaperTypeList.interfaceInfoTable.tableData[0] = {
  desc: '获取questionV4试题来源',
  url: '/api/v1/invoke-v2/questionV4/questionPaperTypes',
  way: 'GET',
  parttern: 'JSON'
}
apiData.questionV4PaperTypeList.yWRequestParamsTable.tableData = [
  { paras: 'stageId', type: 'Int', required: '必填', description: '学段Id' },
  { paras: 'examCategory', type: 'Int', required: '非必填', description: '来源分类，1 备课来源，3 备考来源，不传查询知识点来源', option: [1, 3] }
]
apiData.questionV4PaperTypeList.responseTable.tableData = [
  { paras: 'id', type: 'Int', description: '来源Id' },
  { paras: 'name', type: 'String', description: '来源名称' },
  { paras: 'ordinal', type: 'Int', description: '排序值' }
]



// WEBPACK FOOTER //
// ./src/pages/front/documentV2/apiData.js